// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalValidatePhoto_container__1_D08","title":"ModalValidatePhoto_title__12iM_","subtitle":"ModalValidatePhoto_subtitle__2IrfN","icon":"ModalValidatePhoto_icon__1kLEC"};